import { useTranslation } from 'react-i18next';
import { Form, Icon, Page } from '@/components';
import { useParams, useNavigate } from 'react-router-dom';
import { EditTaskTemplatePanel } from '@/views';
import { Button, Space } from 'antd';
import { useGetTaskTemplateDetailsQuery } from '@/redux';
import { AdminTabKeys } from '@/views/Admin/AdminTabs';

const useId = () => {
  const { id } = useParams<'id'>();
  return id!;
};

export function GlobalTaskTemplateEditPage() {
  const id = useId();
  const { data } = useGetTaskTemplateDetailsQuery({ id });
  const { t } = useTranslation();
  const title = t('taskTemplates.details.editTitle');
  const push = useNavigate();
  const backRoute = `/admin#${AdminTabKeys['task-templates']}`;

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href={backRoute}>{t('taskTemplates.title')}</Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          actionsPosition="bottom"
          actions={
            <Space size="middle">
              <Button onClick={() => push(backRoute)}>{t('cancel')}</Button>
              <Form.Submit uid="taskTemplate-details" type="primary">
                {t('save')}
              </Form.Submit>
            </Space>
          }
          title={title}
          icon={<Icon type="template" />}
          color="#EFAC4E"
        >
          <EditTaskTemplatePanel
            id={id}
            communityId={data?.communityId}
            onSaved={() => push(-1)}
          />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
